/**
 * Connection snippets shown in the MCP connector popup (`McpKeyModal`).
 *
 * Kept in its own dependency-free module (no React / no `shared`) so the snippet
 * generation can be unit-tested in isolation.
 */

export interface McpSnippet {
  /** i18n key for the snippet's display label (resolved via `t()` in the modal). */
  labelKey: string;
  /** The copy-able command/config text. */
  code: string;
}

/**
 * Build the copy-able connection snippets for the popup.
 *
 * `serverUrl` is the per-tenant DERIVED MCP URL (`<backend host>/mcp`) and `key` is the
 * revealed API key (or a placeholder). Both are interpolated into every command — the URL
 * is never hardcoded, since each client runs a separate deployment.
 */
export const buildMcpSnippets = (serverUrl: string, key: string): McpSnippet[] => [
  {
    labelKey: "mcpKey.snippetClaudeDesktop",
    code: `npx mcp-remote ${serverUrl} --header "X-API-Key: ${key}"`,
  },
  {
    labelKey: "mcpKey.snippetClaudeCli",
    code: `claude mcp add --transport http appsuite ${serverUrl} --header "X-API-Key: ${key}"`,
  },
  {
    labelKey: "mcpKey.snippetOpenai",
    code: `server_url: ${serverUrl}\nauthorization: ${key}`,
  },
  {
    labelKey: "mcpKey.snippetGemini",
    code: `streamablehttp_client("${serverUrl}", headers={"X-API-Key": "${key}"})`,
  },
];
